<template>
  <div class="wlx-sty-learn-upload-wrapper">
    <el-tabs tab-position="top" style="height: auto" v-model="tabName" @tab-click="handleClick">
      <el-tab-pane label="视频资源" name="first">
        <el-row v-if="docType == 1">
          <el-col style="width:20%; margin-top: 16px;margin-right: 20px;">
            <el-card
              :body-style="{ padding: '0px' }"
              style="height:270px;text-align: center;line-height:270px;"
              @click="upload"
            >
              <uploadFileLearning
                accept=".mp4"
                :url="urlAliyunOSS"
                :files="files"
                @done="onAllFilesUpload"
              ></uploadFileLearning>
            </el-card>
          </el-col>
          <el-col :span="8" v-for="(li, index) in list" :key="index" style="width:20%;height:270px;margin-right:20px;">
            <el-card :body-style="{ padding: '0px' }" style="height:270px;">
              <video :src="li.DocUrl" class="image" width="100%" height="182px" controls preload="auto"></video>
              <div style="padding: 14px;">
                <p class="name">{{li.DocTitle}}</p>
                <div class="bottom clearfix">
                  <time class="time">{{ li.DateCreated }}</time>
                  <el-button
                    type="text"
                    class="el-icon-delete"
                    @click="deleteLearningSource(li.Id)"
                  ></el-button>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>

        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="onPageChangeHandler"
          :current-page="page"
          :page-sizes="[10, 25, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          v-show="total>0"
        ></el-pagination>
      </el-tab-pane>

      <el-tab-pane label="文档资源" name="second">
        <el-row v-if="docType == 2">
          <el-col style="width:20%; margin-top: 16px;margin-right: 20px;">
            <el-card
              :body-style="{ padding: '0px' }"
              style="height:270px;text-align: center;line-height:270px;"
              @click="upload"
            >
              <uploadFileLearning
                accept=".gif, .doc, .docx, .txt, .xls, .xlsx, .pdf"
                :url="urlAliyunOSS"
                :files="files"
                @done="onAllFilesUpload"
              ></uploadFileLearning>
            </el-card>
          </el-col>
          <el-col :span="8" v-for="(li, index) in list" :key="index" style="width:20%;height:270px;">
            <el-card :body-style="{ padding: '0px' }" style="height:270px;">
              <img
                src="https://file.clpp.org.cn/66ykt/ori/2tv3anmogrronofrjgafcw/xs8aNAsYm6WAWaZt.jpg"
                class="image" style="width:100%;height:182px;"
              >
              <div style="padding: 14px;">
                <p class="name">{{li.DocTitle}}</p>
                <div class="bottom clearfix">
                  <time class="time">{{ li.DateCreated }}</time>
                  <el-button
                    type="text"
                    class="el-icon-delete"
                    @click="deleteLearningSource(li.Id)"
                  ></el-button>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>

        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="onPageChangeHandler"
          :current-page="page"
          :page-sizes="[10, 25, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          v-show="total>0"
        ></el-pagination>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { MU_UPATE_AUTH } from "store/index";
import uploadFileLearning from "components/UploadFileForLearning.vue";
export default {
  data() {
    return {
      tabName: "first",
      currentDate: new Date(),
      urlAliyunOSS: "/api/design/osssign/getsign",
      files: "",
      docType: 1,
      list: [],
      pageSize: 10,
      page: 1,
      total: 0
    };
  },
  components: {
    uploadFileLearning
  },
  props: {
    learnId: {
      type: String
    }
  },
  created() {
    
    var that = this;
    if (localStorage["userId"] !== undefined) {
      that.$store.dispatch(MU_UPATE_AUTH).then(rt => {});
    }
    this.getLearningSource();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.getLearningSource();
    },
    onPageChangeHandler(val) {
      this.page = val;
      this.getLearningSource();
    },
    handleClick(tab, event) {
      if (tab.name == "second") {
        this.docType = 2;
      } else {
        this.docType = 1;
      }
      this.pageSize = 10;
      this.page = 1;
      this.getLearningSource();
    },
    upload() {},
    getLearningSource() {
      var that = this;
      this.$http
        .post("/api/XOrg/LearningMaterialManager/getLearningSource", {
          learnId: this.learnId,
          docType: this.docType,
          page: this.page,
          pageSize: this.pageSize
        })
        .then(function(rst) {
          that.list = rst.list;
          that.pageSize = rst.pagination.pageSize;
          that.total = rst.pagination.totalCount;
        });
    },
    onAllFilesUpload(data) {
      var that = this;
      this.$http
        .post("/api/XOrg/LearningMaterialManager/saveLearningSource", {
          courseWareId: data,
          docType: this.docType,
          learnId: this.learnId
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.page = 1;
            that.getLearningSource();
            that.$message.success("上传成功");
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    deleteLearningSource(id) {
      var that = this;
      this.$http
        .post("/api/XOrg/LearningMaterialManager/deleteLearningSource", {
          Id: id
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.$message.success(rst.msg);
            that.getLearningSource();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    }
  },
  computed: {}
};
</script>

<style lang="scss">
.wlx-sty-learn-upload-wrapper {
  .el-tabs__header {
    position: fixed;
    top: 60px;
    right: 0;
    height: 60px;
    width: calc(100% - 240px);
    z-index: 1000;
    background: #fff;
    text-align: right;
  }
  .el-tabs__item {
    width: 120px;
    text-align: center;
    height: 60px;
    line-height: 60px;
    font-size: 16px;
  }
  .el-tabs__content {
    margin: 80px 0 0 30px;
    background: #fff;
    .el-tab-pane {
      padding: 20px;
    }
  }
  .el-pagination{
    text-align: center;
    padding-top: 20px;
  }
  .bottom{
    line-height: 40px;
  }
  .name{
    width: 215px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .el-icon-delete{
    float: right;
  }
  .image{
    object-fit: fill;
  }
  .el-button--text{
    color: #f00;
  }
}
</style>